export const Columns = [
    {
        name: "checkbox",
        label: "",
        // show: true,
        // width: 40
    },
    {
        name: "id",
        label: "SNo.",
        sort: false,
    },
    {
        name: "name",
        label: "Session Title",
        sort: true,
    },

    {
        name: "language",
        label: "Language",
        sort: true,
    },
    {
        name: "counselorName",
        label: "Mentor",
        sort: true,
    },
    // {
    //     name: "counselorStatus",
    //     label: "CA Status",
    //     sort: true,
    // },
    {
        name: "type",
        label: "Type",
        sort: true,
    },
    {
        name: "duration",
        label: "Duration",
        sort: true,
    },
    {
        name: "date",
        label: "Scheduled On",
        sort: true,
    },
    {
        name: "recLink",
        label: "Rec Link",
        sort: false,
    },
    {
        name: "action",
        label: "",
        sort: false,
        // width: "100px",
    },
];
